import React, { useCallback, useEffect, useMemo, useRef, useContext } from "react";
import { useSDK } from "./sdk";
import { useStore } from "./store";
import {
	Symbology,
} from "scandit-web-datacapture-barcode";
import styles from '../styles/QRScanner.module.scss';
import { SharedInfoContext } from '../components/SharedInfoContextProvider';

export default function QRComponent(props) {
const host = useRef(null);
const { loaded, loading, sdk } = useSDK();
const { setBarcode, keepCameraOn } = useStore();
const { registerNumber, updateRegisterNumber } = useContext(SharedInfoContext);
const { frontGateQR, updateFrontGateQR } = useContext(SharedInfoContext);

const shouldKeepCameraOn = useCallback(async () => {
	if (!keepCameraOn) {
		await sdk.enableCamera(false);
	}
}, [sdk, keepCameraOn]);

const onScan = useMemo(
() => ({
	didScan: async (_, session) => {
	if (session.newlyRecognizedBarcodes.length > 0) {
		props.setScanFlg(true);
		await sdk.enableScanning(false);
		await shouldKeepCameraOn();
		// setBarcode(session.newlyRecognizedBarcodes[0]);

		const barcode = session.newlyRecognizedBarcodes[0];
		// const symbology = new barcode.SymbologyDescription(barcode.symbology);
		const symbology = barcode.symbology;
		const data = barcode.data;
		const addOnData = barcode.addOnData;

		console.log("-------------------------");
		console.log("【newlyRecognizedBarcodes】");
		console.log("symbology: " + symbology);
		console.log("data: " + data);
		console.log("-------------------------");

		setBarcode(data);
		props.setQRcode(data);
		//二重送信対応テスト
		//props.setQRcode("123456789");
		// setQRcode(data);
		updateFrontGateQR(data);
		updateRegisterNumber(data);
		// saleslistAPI();
	}
	},
}),
// [setBarcode, sdk, navigate, shouldKeepCameraOn]
[setBarcode, sdk, shouldKeepCameraOn]
);


useEffect(() => {

if(loaded){
	console.log("scandit sdk: " + "loaded");
}else if(loading){
	console.log("scandit sdk: " + "loading");
}

async function onMount() {
	if (loaded && host.current) {
	sdk.connectToElement(host.current);
	await sdk.enableCamera(true);
	await sdk.enableScanning(true);
	await sdk.enableSymbology(Symbology.Code128,false);
	await sdk.enableSymbology(Symbology.EAN8,false);
	await sdk.enableSymbology(Symbology.EAN13UPCA,false);
	await sdk.enableSymbology(Symbology.UPCE,false);
	await sdk.enableSymbology(Symbology.QR,true);
	sdk.addBarcodeCaptureListener(onScan);
	}
}

onMount();

return () => {
	if (loaded) {
	sdk.removeBarcodeCaptureListener(onScan);
	sdk.detachFromElement();
	}
};
}, [loaded, loading, sdk, onScan]);

return <div ref={host} className={styles.scanImg} />;
}
